export class Territory {
    constructor(
            public id: number  = null,
            public territory_id: number = null,
            public territory: string = null,
            public name: string = '') {}
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/list/territory.ts